import { useState } from "react";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "../../components/admin/AuthContext";
import { AuthShell } from "../../components/admin/AuthShell";
import { formatApiError } from "../../lib/api";
import { FormAlert, inputClass } from "../../components/forms/FormKit";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const from = useLocation().state?.from || "/admin";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to={from} replace />;

  const submit = async (e) => {
    e.preventDefault();
    if (!email || !password) return setError("Enter your email and password.");
    setBusy(true);
    setError("");
    try {
      await login(email, password);
      navigate(from, { replace: true });
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell title="Administrator sign in">
      <form onSubmit={submit} noValidate data-testid="admin-login-form">
        <h1 className="font-display text-3xl font-semibold tracking-tight text-[#0B1220]">Sign in</h1>
        <p className="mt-2 text-sm text-slate-500">Administrator accounts are provisioned by invitation only. There is no public registration.</p>
        <div className="mt-10 space-y-5">
          <div>
            <label htmlFor="admin-email" className="mb-2 block text-sm font-medium text-[#111827]">Email</label>
            <input id="admin-email" type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} className={inputClass(false)} data-testid="admin-login-email-input" />
          </div>
          <div>
            <div className="mb-2 flex items-center justify-between">
              <label htmlFor="admin-password" className="block text-sm font-medium text-[#111827]">Password</label>
              <Link to="/admin/forgot-password" className="text-xs font-semibold text-[#2563EB]" data-testid="admin-forgot-password-link">Forgot password?</Link>
            </div>
            <input id="admin-password" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} className={inputClass(false)} data-testid="admin-login-password-input" />
          </div>
          <FormAlert message={error} testId="admin-login-error" />
          <button type="submit" disabled={busy} className="btn-primary w-full" data-testid="admin-login-submit-button">
            {busy ? <><Loader2 className="h-4 w-4 animate-spin" /> Signing in</> : "Sign in"}
          </button>
        </div>
      </form>
    </AuthShell>
  );
}
